export default __webpack_public_path__ + "static/media/KOD0011-min.98d4077a.webp";